import { Screen } from '@betty/navigation';
import { DepositInteracURLScreenProps } from './DepositInteracURLScreen.types';
import DepositInteracURL from '../../components/DepositInteracURL/DepositInteracURL';

function DepositInteracURLScreen({ route }: DepositInteracURLScreenProps) {
  const { url } = route.params;

  return (
    <Screen paddingHorizontal="space-0">
      <DepositInteracURL url={url} />
    </Screen>
  );
}

export default DepositInteracURLScreen;
